"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _md = require("react-icons/md");

var _Typography = _interopRequireDefault(require("../../Typography/Typography"));

var _IconButton = _interopRequireDefault(require("../../IconButton/IconButton"));

var _FormControl = _interopRequireDefault(require("../../Form/FormControl/FormControl"));

var _system = _interopRequireDefault(require("../../../utils/system"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  canNextPage: _propTypes.bool.isRequired,
  canPreviousPage: _propTypes.bool.isRequired,
  dense: _propTypes.bool,
  nextPage: _propTypes.func.isRequired,
  pageCount: _propTypes.number.isRequired,
  pageIndex: _propTypes.number.isRequired,
  pageOptions: (0, _propTypes.oneOfType)([_propTypes.array]).isRequired,
  pageSize: _propTypes.number.isRequired,
  previousPage: _propTypes.func.isRequired,
  rowsPerPageOptions: (0, _propTypes.arrayOf)(_propTypes.number),
  setPageSize: _propTypes.func.isRequired
};
var defaultProps = {
  dense: false,
  rowsPerPageOptions: [10, 20, 30, 40]
};
var TablePagination = (0, _system["default"])('div')({
  label: 'TablePagination'
}, function (_ref) {
  var dense = _ref.dense;
  return (0, _css["default"])({
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-end',
    py: dense ? 1 : 4
  });
});
var Typography = ( /*#__PURE__*/0, _base["default"])(_Typography["default"], process.env.NODE_ENV === "production" ? {
  target: "e1sghc771"
} : {
  target: "e1sghc771",
  label: "Typography"
})((0, _css["default"])({
  px: 4,
  whiteSpace: 'nowrap'
}));
var Select = ( /*#__PURE__*/0, _base["default"])(_FormControl["default"], process.env.NODE_ENV === "production" ? {
  target: "e1sghc770"
} : {
  target: "e1sghc770",
  label: "Select"
})((0, _css["default"])({
  border: 'none',
  cursor: 'pointer',
  maxWidth: '56px',
  px: 1
}));
var Component = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var canPreviousPage = _ref2.canPreviousPage,
      canNextPage = _ref2.canNextPage,
      pageIndex = _ref2.pageIndex,
      pageOptions = _ref2.pageOptions,
      pageCount = _ref2.pageCount,
      setPageSize = _ref2.setPageSize,
      nextPage = _ref2.nextPage,
      previousPage = _ref2.previousPage,
      pageSize = _ref2.pageSize,
      rowsPerPageOptions = _ref2.rowsPerPageOptions,
      props = _objectWithoutProperties(_ref2, ["canPreviousPage", "canNextPage", "pageIndex", "pageOptions", "pageCount", "setPageSize", "nextPage", "previousPage", "pageSize", "rowsPerPageOptions"]);

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(TablePagination, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Typography, {
      variant: "caption",
      children: "Rows per page:"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Select, {
      as: "select",
      size: "sm",
      value: pageSize,
      onChange: function onChange(e) {
        setPageSize(Number(e.target.value));
      },
      children: rowsPerPageOptions.map(function (rowsPerPageOpt) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: rowsPerPageOpt,
          children: rowsPerPageOpt
        }, rowsPerPageOpt);
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Typography, {
      variant: "caption",
      children: [pageIndex + 1, " of ", pageOptions.length]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
      size: "sm",
      onClick: previousPage,
      disabled: !canPreviousPage,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_md.MdKeyboardArrowLeft, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
      size: "sm",
      onClick: nextPage,
      disabled: !canNextPage,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_md.MdKeyboardArrowRight, {})
    })]
  }));
});
Component.displayName = 'TablePagination';
Component.propTypes = propTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=TablePagination.js.map